export default class LevelDataController {
  constructor(game, levelData) {
    this.game = game;
    this.levelData = { ...levelData };
  }
}
